export const UserRoles = {
    ADMIN: "ADMIN",
    DIRECTION_GENERALE: "DIRECTION_GENERALE",
    DIRECTION_EDUCATION_ET_GOUVERNANCE: "DIRECTION_EDUCATION_ET_GOUVERNANCE",
    //AGENT_CNEA: "AGENT_CNEA",
    COORDINATEUR_REGIONAL: "COORDINATEUR_REGIONAL",
    ENSEIGNANT: "ENSEIGNANT"
}

export const AllRoles = ["ADMIN", "DIRECTION_GENERALE", "DIRECTION_EDUCATION_ET_GOUVERNANCE", "AGENT_CNEA", "COORDINATEUR_REGIONAL","ENSEIGNANT"];